/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Header from '../companies/header'
import ArrowBack from '@components/arrowBack'
import FilterIcon from '@assets/icons/sort-svgrepo-com.svg'
import { useNavigate } from 'react-router-dom'
import Select from '@components/inputs/select'
import Loading from '@components/loading'
import {
  FaceRecognitionContainer, ArrowBackContainer, ArrowBackTextContainer,
  FaceRecognitionContent, FaceRecognitionContentHeader,
  InputContainer, SearchIcon, Table, TableContainer,
  Tr, Th, Thead, Td, NameCell, ProfileImage,
  PaginationContainer, PaginationButtonContainer,
  PaginationButton, PaginationButtonActive, Row, LoadingContainer,
} from './styles'
import TextInput from '@components/inputs/textInput'
import { Tbody } from '@components/table/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getBeneficiariesToAccessControl } from '@stores/actions/beneficiary'
import colors from '@settings/styleSettings'
import SockJS from 'sockjs-client'
import PropTypes from 'prop-types'
import { Client } from '@stomp/stompjs'

const FaceRecognition = ({ getBeneficiariesToAccessControl }) => {
  const [accessControlBeneficiaries, setAccessControlBeneficiaries] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortedData, setSortedData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)
  const [lengthOfData, setLengthOfData] = useState(0)

  const navigate = useNavigate()

  useEffect(() => {
  const raw = localStorage.getItem('accessToken') || ''
  const jwt = raw.startsWith('Bearer ') ? raw.slice(7) : raw
  const sockUrl = `http://localhost:8080/saude-preventiva/ws?token=${encodeURIComponent(jwt)}`


    const client = new Client({
      reconnectDelay: 5000,
      connectHeaders: raw ? { Authorization: raw.startsWith('Bearer ') ? raw : `Bearer ${raw}` } : {},
      // quando usa SockJS, NÃO defina brokerURL
      webSocketFactory: () => new SockJS(sockUrl),
      onConnect: () => {
        client.subscribe('/topic/accessControlBeneficiaries', (message) => {
          const newBeneficiary = JSON.parse(message.body)

          setSortedData(prevState => {
            // deduplicação por entryTime (ou refine com cpf+entryTime)
            const exists = prevState.some(b => b.entryTime === newBeneficiary.entryTime)
            if (exists) return prevState
            const updatedList = [newBeneficiary, ...prevState]
            if (updatedList.length > itemsPerPage) { // <<< sem +1
              updatedList.pop()
            }
            return updatedList
          })

          setLengthOfData(prev => (typeof prev === 'number' ? prev + 1 : 1))
        })
      },
      onStompError: (frame) => {
        // opcional: console.error('STOMP error:', frame.headers.message)
      },
      onWebSocketError: (e) => {
        // opcional: console.error('WS error', e)
      },
    })

    client.activate()
    return () => {
      try { client.deactivate() } catch (_) {}
    }
  }, []) // <<< conecta 1x

  // Busca inicial via Redux (mantive seu fluxo original)
  const fetchData = (page, limit) => {
    setLoading(true)
    const callback = (data) => {
      updateList((data && data.content) || [])
      setLoading(false)
      setLengthOfData(typeof data?.totalElements === 'number' ? data.totalElements : 0)
    }
    const params = { page, limit }
    getBeneficiariesToAccessControl(params, callback)
  }

  useEffect(() => {
    fetchData(currentPage, itemsPerPage)
  }, [currentPage, itemsPerPage])

  const updateList = (data) => {
    setAccessControlBeneficiaries(data || [])
    setSortedData(data || [])
  }

  const getOnlyDate = (date) => {
    if (!date) return ''
    const s = String(date)
    if (s.includes('T')) return s.split('T')[0] 
    const parts = s.split(' ')
    return parts[0] || ''
  }

  const getOnlyTime = (date) => {
    if (!date) return ''
    const s = String(date)
    if (s.includes('T')) {
      const t = s.split('T')[1] || ''
      return t.replace('Z', '').slice(0, 8)
    }
    const parts = s.split(' ')
    return (parts[1] || '').slice(0, 8)
  }

  const handleSort = (column) => {
    const sorted = [...sortedData].sort((a, b) => {
      let aValue = a[column]
      let bValue = b[column]
      if (column === 'entryTime') {
        aValue = getOnlyDate(a.entryTime)
        bValue = getOnlyDate(b.entryTime)
      } else if (column === 'hour') {
        aValue = getOnlyTime(a.entryTime)
        bValue = getOnlyTime(b.entryTime)
      }
      const A = (aValue ?? '').toString()
      const B = (bValue ?? '').toString()
      return sortOrder === 'asc' ? A.localeCompare(B) : B.localeCompare(A)
    })
    setSortedData(sorted)
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
  }

  const handleSearch = (event) => {
    const value = (event.target.value || '').toLowerCase()
    setSearchTerm(value)
    const filteredData = accessControlBeneficiaries.filter((beneficiary) =>
      (beneficiary.name || '').toLowerCase().includes(value)
    )
    setSortedData(filteredData)
  }

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }

  const handleNextPage = () => {
    const totalPages = Math.ceil((lengthOfData || 0) / itemsPerPage)
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }

  const handleItemsPerPageChange = (selectedOption) => {
    setItemsPerPage(selectedOption.value)
    setCurrentPage(1)
  }

  const getPaginationButtons = () => {
    const totalPages = Math.ceil((lengthOfData || 0) / itemsPerPage)
    const buttons = []
    const maxButtons = 3
    let startPage = Math.max(currentPage - Math.floor(maxButtons / 2), 1)
    let endPage = startPage + maxButtons - 1

    if (endPage > totalPages) {
      endPage = totalPages
      startPage = Math.max(endPage - maxButtons + 1, 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <PaginationButtonActive
          key={i}
          active={currentPage === i}
          onClick={() => { setCurrentPage(i) }}
        >
          {i}
        </PaginationButtonActive>
      )
    }
    return buttons
  }

  const options = [
    { value: 5, label: '5 Linhas' },
    { value: 10, label: '10 Linhas' },
    { value: 20, label: '20 Linhas' },
    { value: 50, label: '50 Linhas' },
  ]

  const totalPages = Math.ceil((lengthOfData || 0) / itemsPerPage)

  return (
    <div>
      <Header />
      <FaceRecognitionContainer>
        <ArrowBackContainer>
          <ArrowBack onClick={() => { navigate(-1) }} />
          <ArrowBackTextContainer>
            <h1>Vida ativa: Consulta de acessos</h1>
            <p>Visualize os acessos a partir do reconhecimento facial</p>
          </ArrowBackTextContainer>
        </ArrowBackContainer>

        <FaceRecognitionContent>
          <FaceRecognitionContentHeader>
            <InputContainer>
              <TextInput
                placeholder="Digite parte do nome ou do CPF"
                value={searchTerm}
                onChange={handleSearch}
              />
              <SearchIcon
                className="material-icons-outlined"
                onClick={() => fetchData(currentPage, itemsPerPage)}
              >
                search
              </SearchIcon>
            </InputContainer>
          </FaceRecognitionContentHeader>

          {loading ? (
            <LoadingContainer>
              <Loading color={colors.primary} height={40} width={40} />
            </LoadingContainer>
          ) : (
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th onClick={() => handleSort('name')}>
                      <NameCell>
                        <img src={FilterIcon} alt="Filter Icon" />
                        <p>Nome</p>
                      </NameCell>
                    </Th>
                    <Th>CPF</Th>
                    <Th>Carteirinha</Th>
                    <Th onClick={() => handleSort('entryTime')}>
                      <NameCell>
                        <img src={FilterIcon} alt="Filter Icon" />
                        <p>Data</p>
                      </NameCell>
                    </Th>
                    <Th onClick={() => handleSort('hour')}>
                      <NameCell>
                        <img src={FilterIcon} alt="Filter Icon" />
                        <p>Horário de Entrada</p>
                      </NameCell>
                    </Th>
                    <Th>Atividade</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {sortedData.map((row) => (
                    <Tr key={row.id || `${row.cpf || row.userId}-${row.entryTime}`}>
                      <Td>
                        <NameCell>
                          {row.profileImageBase64 ? (
                            <img
                              src={`data:image/jpeg;base64,${row.profileImageBase64}`}
                              alt={row.name}
                              style={{ width: 40, height: 40, borderRadius: '50%', marginLeft: '20px' }}
                              loading="lazy"
                            />
                          ) : (
                            <ProfileImage>{(row.name || '?')[0]}</ProfileImage>
                          )}
                          {row.name}
                        </NameCell>
                      </Td>
                      <Td>{row.cpf}</Td>
                      <Td>{row.insurance_number}</Td>
                      <Td>{getOnlyDate(row.entryTime)}</Td>
                      <Td>{getOnlyTime(row.entryTime)}</Td>
                      <Td>{row.activityName}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </FaceRecognitionContent>

        <PaginationContainer>
          <div>
            <span>
              {`${(currentPage - 1) * itemsPerPage + 1} - ${Math.min(currentPage * itemsPerPage, lengthOfData || 0)} de ${lengthOfData || 0} resultados`}
            </span>
          </div>
          <PaginationButtonContainer>
            <PaginationButton onClick={handlePreviousPage} disabled={currentPage === 1}>
              &lt;
            </PaginationButton>
            {getPaginationButtons()}
            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
              &gt;
            </PaginationButton>
          </PaginationButtonContainer>
          <div>
            <label>
              <Row>
                <span>Mostrar: </span>
                <Select
                  value={options.find(option => option.value === itemsPerPage)}
                  onChange={handleItemsPerPageChange}
                  options={options}
                />
              </Row>
            </label>
          </div>
        </PaginationContainer>
      </FaceRecognitionContainer>
    </div>
  )
}

FaceRecognition.propTypes = {
  getBeneficiariesToAccessControl: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getBeneficiariesToAccessControl
}, dispatch)

export default connect(null, mapDispatchToProps)(FaceRecognition)
